const RETRYABLE_PATTERNS = /network|timeout|disconnect|server_error|NETWORK_ERROR|NETWORK_TIMEOUT|CAN_NOT_GET_GATEWAY_SERVER|CAN_NOT_GET_PROXY_SERVER|OPERATION_ABORTED|WS_ABORT|WS_DISCONNECT|ERR_NETWORK/i;

export default {
  isNetworkError(error) {
    return RETRYABLE_PATTERNS.test(error.code) || RETRYABLE_PATTERNS.test(error.message);
  }
}
